module.exports = __webpack_public_path__ + "img/iconRecruit.e43f3268.png";